import axios from "axios";
export default {
    getWorkSpace: (workSpaceId) => axios.post("/WorkSpaces/GetWorkSpaceDetailed", { Id: workSpaceId })
};
